<template>
  <div class="w-full" v-if="isCardActiveLocal">
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <user-details :loading="loadingDetails" :userDetails="userDetails" :myTime="userDetailsObject.timeSpentAvgStudent" :avgTime="userDetailsObject.timeSpentAvgGrade" :radialData="[userDetailsObject.scoreAvgStudent,userDetailsObject.scoreAvgGrade]"/>
      </div>
    </div>
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Modules</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="moduleFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col mb-3" v-for="(mod, index) in modules" :key="index" style="padding-left: 0; padding-right: 0;">
            <data-card :smallText="true" class="mx-2" type="Module" @handleModuleClick="selectedModule(mod)" :title="mod.moduleName" :myTime="mod.timeSpentAvgStudent" :avgTime="mod.timeSpentAvgGrade" :radialData="[mod.scoreAvgStudent, mod.scoreAvgGrade]"/>
          </div>          
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :count="4"/>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfModulesForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore"  @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfModulesForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "Modules",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsTime:true,
      loadingChartsScore:true,
      modules: [],
      originalModules: [],
      moduleFilterText: "",
      listOfModulesForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getModules();
        self.fetchUserDetails();
        localStorage.setItem("Guardian_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","2");
      }
    },
    moduleFilterText: function(val) {
      var self = this;
      if(val) {
        self.modules = self.originalModules.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.modules = self.originalModules;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getModules() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;

      var onSuccess = function(response) {
        self.modules = response.data;
        self.listOfModulesForDropdown = self.modules.map((item) => {return { label: item.moduleName, value: item.moduleId }});

        self.originalModules = self.modules;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };
      self.$ajaxGet(self, `GuardianDashboard/ListSubjectModules?userId=${self.userDetails.id}&gradeId=${self.userDetails.gradeId}&subjectId=${self.userDetails.selectedSubject.subjectId}`, onSuccess, onFinally);
    },
    selectedModule(module){
      this.$emit('selectedModule', module);
      this.userDetails.selectedModule = module;
    },
    filterDropdownChangedStudentGraphTimeSpent(moduleName,moduleId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
    
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphTimeSpent?studentId=${this.userDetails.id}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&courseId=${this.userDetails.selectedSubject.subjectId}&moduleCategoryId=${moduleId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(moduleName,moduleId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `GuardianDashboard/StudentGraphScore?studentId=${this.userDetails.id}&month=${selectedDate.monthIndex}&year=${selectedDate.year}&courseId=${this.userDetails.selectedSubject.subjectId}&moduleCategoryId=${moduleId}` , onSuccess, onFinally);
    },
    fetchUserDetails() {
      var self = this;
      this.loadingDetails = true;
      var onSuccess = response =>{
        self.userDetailsObject = response.data;
        self.loadingDetails = false;
      }
      var onFinally = response =>{
        self.loadingDetails = false;
      }
      self.$ajaxGet(self, `GuardianDashboard/UserDetailsForDashboard?userId=${this.userDetails.id}&gradeId=${self.userDetails.gradeId}&subjectId=${this.userDetails.selectedSubject.subjectId}` , onSuccess, onFinally);
    },
  },
  created() {
    var self = this;
    
  },
  mounted() {
    var self = this;
  }
};
</script>